import { render, staticRenderFns } from "./addCommunityPublicityList.vue?vue&type=template&id=215b5595&scoped=true"
import script from "./addCommunityPublicityList.vue?vue&type=script&lang=js"
export * from "./addCommunityPublicityList.vue?vue&type=script&lang=js"
import style0 from "./addCommunityPublicityList.vue?vue&type=style&index=0&id=215b5595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b5595",
  null
  
)

export default component.exports